import { FC, ReactNode, useEffect, useMemo, useState } from 'react';

import { useClients } from '../hooks/data/useClients';
import { ClientContext } from './MainContextService';
import { Client } from 'contentful/getClients';

export const ClientsProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [clients, setClients] = useState<Client[] | null>(null);

    const { data } = useClients();

    useEffect(() => {
        if (data && !clients) {
            setClients(data as unknown as Client[]);
        }
    }, [data, clients]);

    const contextValue = useMemo(
        () => ({
            clients,
        }),
        [clients],
    );

    return <ClientContext.Provider value={contextValue}>{children}</ClientContext.Provider>;
};
